module.exports = __webpack_public_path__ + "static/media/gdn_workstep3.e510d5c0.webp";